<template>
    <div id="header">
        <div class="type_area header">
            <img src="../assets/images/common/logo.png" alt="">
            <img @click='show' src="../assets/images/common/菜单.png" alt="">
        </div>
    </div>
</template>


<script>
export default {
    data(){
        return{
            
        }
    },
    methods:{
        // 显示菜单模态框
        show(){
            this.$Bus.$emit('show',true); // 传值给其它组件
        }
    },
}
</script>



<style scoped lang="less">
    #header{
        width:100%;
        height:3rem;
        background:#F0F2F5;
        position:fixed;
        top: 0;
        z-index: 999;
        .header{
            height:100%;
            display:flex;
            justify-content: space-between;
            align-items: center;
            img{
                height:50%;
            }
        }
    }
</style>